import * as React from 'react';
import styled, { css } from 'styled-components';
import { borderRadius, colors, gutter } from '../../../../styles/variables';

const Warpper = styled.div`
  margin-bottom: ${gutter.large};
  display: block;
  text-align: -webkit-center;

  ${props => props.margin === false && css`
    margin: 0;
  `}
`;

const Label = styled.label`
  position: relative;
  /* width: 98px; */
  width: 100%;
  height: 98px;
  border: 1px dashed ${colors.primary.default};
  border-radius: ${borderRadius.default};
  display: block;
  padding: 1.2em;
  cursor: pointer;
  /* text-align: center; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 auto;
  overflow: hidden;
`;

const Span = styled.span`
  color: ${colors.primary.default};
`;

const InputTypeFile = styled.input`
  display: none;
`;

const FootLabel = styled.div`
  position: absolute;
  text-align: center;
  background: ${colors.primary.default};
  width: 102%;
  left: -2px;
  color: #000;
  border-radius: 0 0 ${borderRadius.default} ${borderRadius.default};
  bottom: -2px;
`;

const ImgPreview = styled.img`
  position: absolute;
  height: 100%;
  border-radius: ${borderRadius};
`;

function InputFile(props){
  return (
    <Warpper margin={props.margin}>
      <Label htmlFor={props.id}>
        { props.previewImage
          ? <ImgPreview src={props.previewImage} />
          : <>
              {props.label && <Span>{props.label}</Span>}
            </>
        }
        <InputTypeFile
          type="file"
          id={props.id}
          name={props.name}
          multiple={!!props.multiple}
          onChange={props.onChange}
        />
        {props.labelFoot && <FootLabel>{props.labelFoot}</FootLabel>}
      </Label>
    </Warpper>
  );
}

export default InputFile;
